import { ProductionOrderListState, ProductionOrderListStore } from './production-order-list.store';
import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { MachineScheduleViewModel } from 'chronos-core-client';

@Injectable({
  providedIn: 'root'
})
export class ProductionOrderListQuery extends QueryEntity<ProductionOrderListState, MachineScheduleViewModel> {
  constructor(protected productionOrderListStore: ProductionOrderListStore) {
    super(productionOrderListStore);
  }
  public isLoading$ = this.selectLoading();
  public hasData$ = this.select((state) => state.hasData);
}
